export default __webpack_public_path__ + "static/media/NoProjects.aeb2c6b7.png";